export class Libreria {
  id;
  nome;
  partitaIva;
  indirizzo;
  richiedeAssociazioneTesseramento;

  bando;
  bando_id;
  comune;
  comune_id;
  comuniAssociati;
  richieste;
  operatore;
  operatori;
}
